import CountUp from "react-countup";

function StatsSection() {
  const stats = [
    {
      number: 18,
      suffix: "+",
      label: "Years of Excellence",
    },
    {
      number: 2500,
      suffix: "+",
      label: "Students",
    },
    {
      number: 100,
      suffix: "+",
      label: "Faculty Members",
    },
    {
      number: 2,
      suffix: "",
      label: "Acre Campus",
    },
  ];

  return (
    <section className="py-20 bg-blue-900 text-white">
      <div className="max-w-7xl mx-auto px-6">

        <div className="grid md:grid-cols-4 gap-10 text-center">

          {stats.map((item, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-md rounded-2xl p-8 hover:scale-105 transition duration-300"
            >
              <h2 className="text-5xl font-bold text-yellow-400 mb-3">
                <CountUp end={item.number} duration={3} />
                {item.suffix}
              </h2>

              <p className="text-lg font-medium">
                {item.label}
              </p>
            </div>
          ))}

        </div>

      </div>
    </section>
  );
}

export default StatsSection;